import { useUI } from "providers/UIProvider"
import { useParams } from "react-router-dom"

import { Flex, Text } from "@chakra-ui/react"

import CompanyBranches from "components/shared/CompanyBranches"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import MainLayout from "../MainLayout"
import ChangeList from "./ChangeList"
import { useLaundryContext } from "providers/LaundryProvider/LaundryProvider"
import { normalizeChangesHistory } from "utils/normalizeChangesHistory"
import { useEffect } from "react"
import MyGoogleMapsModal from "components/shared/modals/MyGoogleMapsModal"

const ChangeHistoryTamplate = () => {
    const { laundryId = "" } = useParams()

    const { T, modals } = useUI()
    const { setState, changesHistory, approveRejectLaundryUpdates, approveRejectLaundryUpdatesLoading } = useLaundryContext()

    const { newValues, oldValues } = normalizeChangesHistory(changesHistory)

    useEffect(() => {
        setState({ laundryId, enabledChangesHistory: true })
    }, [])

    return (
        <MainLayout navigation>
            <Flex >
                <CompanyBranches />
            </Flex>
            <Flex width={"100%"} flexDirection={"column"} borderRadius={"10px"} mt={"20px"} backgroundColor="#ffffff">
                <Flex pl={"24px"} w={"100%"} borderBottomWidth={"1px"} borderColor="#E9F2FD" h={"73px"} alignItems={"center"}>
                    <Text fontSize={"18px"} lineHeight={"36px"}>
                        {T("laundry.changes_history.title")}
                    </Text>
                </Flex>
                <Flex padding="0 24px" width={"100%"} gap={"31px"} justifyContent="space-between">
                    <ChangeList items={oldValues} title={T("laundry.changes_history.current")} isCurrent={false} />
                    <ChangeList items={newValues} title={T("laundry.changes_history.required_updates")} isCurrent={true} />
                </Flex>
                <Flex
                    mb={"77px"}
                    gap={"30px"}
                    mt={"70px"}
                    width="100%"
                    justifyContent="center"
                >
                    <Button
                        text={T("actions.deny")}
                        onClick={() => approveRejectLaundryUpdates({ carWashId: Number(laundryId), status: 2 })}
                        variant="error"
                        leftIcon={
                            <Icon
                                name="close_rounded"
                                iconStyles={{ width: "30px", height: "30px" }}
                            />
                        }
                        styles={{ width: "220px", height: "63px", fontSize: "m" }}
                        isDisabled={approveRejectLaundryUpdatesLoading}
                    />
                    <Button
                        text={T("actions.confirm")}
                        onClick={() => approveRejectLaundryUpdates({ carWashId: Number(laundryId), status: 1 })}
                        variant="success"
                        leftIcon={
                            <Icon name="confirm" iconStyles={{ width: "30px", height: "30px" }} />
                        }
                        styles={{ width: "220px", height: "63px", fontSize: "m" }}
                        isDisabled={approveRejectLaundryUpdatesLoading}
                    />
                </Flex>
            </Flex>
            {modals.myGoogleMapsModal && <MyGoogleMapsModal />}
        </MainLayout>
    )
}
export default ChangeHistoryTamplate